export enum StatusLoaded{
    Loaded = 14,
    DroppedFull = 23
}